import { Button } from "../../Styles/Global.Styled";
import { css } from "styled-components";

const sideBarCloseBttn = css`
  font-family: ${({ theme }) => theme.testFont};
  align-self: flex-end;
  width: 4vh;
  height: 4vh;
  font-size: 3.5vh;
  font-weight: 600;
`;

const ClosePopupButton = ({ setPopUp }) => {
  return (
    <Button
      type="button"
      $baseStyle={sideBarCloseBttn}
      onClick={() => setPopUp({ isOpen: false })}
    >
      x
    </Button>
  );
};

export default ClosePopupButton;
